<button type="button" class="btn btn-sm btn-info" (click)="showPopup()"><span class="glyphicon glyphicon-folder-open"></span> Dokumente</button>

<dx-popup class="popup"
          title="Dokumente"
          [showTitle]="true"
          [height]="'90%'"
          [width]="'80%'"
          [(visible)]="popupVisible"
          (onShowing)="onShowingPopup($event)"
          style="display: inline-block;">
  <div *dxTemplate="let data of 'content'">
    <dx-scroll-view #scrollView
                    id="scrollview"
                    [scrollByContent]="true"
                    [scrollByThumb]="true"
                    [showScrollbar]="'onHover'"
                    reachBottomText="Updating...">
      <div style="padding-right: 15px;">
        <cz-dokumente #dokComp
                      [entityArt]="entityArt"
                      [ownerId]="ownerId"></cz-dokumente>
      </div>
    </dx-scroll-view>
  </div>

  <dxi-popup-toolbar-item widget="dxButton"
                    location="after"
                    toolbar="bottom"
                    [options]="{
            text: 'Schließen',
            onClick: hidePopup
        }">
  </dxi-popup-toolbar-item>
</dx-popup>
